import React from 'react';
import { Sun, Moon } from 'lucide-react';
import css from './ThemeToggle.module.css';

// Light/dark toggle, rendered in the sitewide Topbar next to the Maps
// link (TopbarDesktop.js / TopbarMobileMenu.js) so it's reachable from any
// page; theme/onToggle come from ThemeContext (src/context/themeContext.js).
// Light is the default look; dark (the "trading card" ink theme built for
// the landing page) is an opt-in a visitor can switch to, persisted so it
// sticks on their next visit. Today only the landing page's own CSS (plus
// EventCard/SubscriptionCard, scoped to the same selector) actually
// changes look with it -- see LandingPage.module.css.
const ThemeToggle = ({ theme, onToggle }) => {
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      className={css.toggle}
      onClick={onToggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
};

export default ThemeToggle;
